import { Component, ViewEncapsulation } from '@angular/core';
import { SchoolTwoColumnLayoutComponent } from 'Src/ng2/school/layouts/school-two-column-layout/school-two-column-layout.component';

@Component({
  templateUrl: './settings-layout.component.html',
  selector: 'settings-layout',
  encapsulation: ViewEncapsulation.None,
})
export class SettingsLayoutComponent extends SchoolTwoColumnLayoutComponent {}
